<script>
  /**
   * Specify background color
   * @type {"bg-1" | "bg-2" | "bg-3" | "bg-4" | "bg-4" | "a1-b" | "measure"}
   */
  export let background = undefined;
</script>

<section class="{background}">
  <slot></slot>
</section>

<style>
	section {
		position: relative;
    padding-bottom: 8rem;
    overflow: hidden;
	}

  .bg-1 { background: var(--bg-1); }
  .bg-2 { background: var(--bg-2); }
  .bg-3 { background: var(--bg-3); }
  .bg-4 { background: var(--bg-4); }
  .bg-5 { background: var(--bg-5); }
  .a1-b { background: var(--a1-b); }
  .measure { background: url("/images/measure.svg") center / auto 100% no-repeat; }
</style>